//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    resultName: {
      type: String,
      default: ''
    },
    resultValue: {
      type: Object,
      default () {
        return {}
      }
    },
    roleExecutor: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: ''
    }
  },
  computed: {
    multiple: function () {
      return this.resultValue.multiselect || false
    }
  }
}

